import { Turbo } from "@hotwired/turbo-rails";

function modalElement(stream) {
  return document.getElementById(stream.getAttribute("target"));
}

function isSprintModalV2(element) {
  return Boolean(element?.classList.contains("sprint-modal-v2"));
}

function closeSprintModalV2(element) {
  element.classList.remove("is-open", "in", "show");
  element.style.removeProperty("display");

  if (!document.querySelector(".sprint-modal-v2.is-open, .sprint-modal-v2.in, .modal.in")) {
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove());
    document.body.classList.remove("modal-open");
    document.body.style.removeProperty("padding-right");
  }

  element.dispatchEvent(new CustomEvent("modal:closed", {
    bubbles: true,
    detail: { modalId: element.id },
  }));
}

function showSprintModalV2(element) {
  element.classList.add("is-open");
}

function controlSprintModalV2(element, action) {
  // Stream updates insert the modal before Stimulus connects its controller.
  window.requestAnimationFrame(() => {
    if (!element.isConnected) { return; }

    const controller = window.Stimulus?.getControllerForElementAndIdentifier(element, "admin--settings--modal");
    if (controller) {
      controller[action]();
    } else if (action === "show") {
      showSprintModalV2(element);
    } else {
      closeSprintModalV2(element);
    }
  });
}

function bootstrapModal(element, action) {
  if (!element || typeof window.jQuery === "undefined") {
    return;
  }

  const $element = window.jQuery(element);
  if (typeof $element.modal === "function") {
    $element.modal(action);
  }
}

Turbo.StreamActions.settings_show_modal = function showModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    controlSprintModalV2(element, "show");
    return;
  }

  bootstrapModal(element, "show");
};

Turbo.StreamActions.settings_hide_modal = function hideModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    controlSprintModalV2(element, "forceClose");
    return;
  }

  bootstrapModal(element, "hide");
};

Turbo.StreamActions.settings_dispose_modal = function disposeModal() {
  const element = modalElement(this);
  if (!element) {
    return;
  }

  if (isSprintModalV2(element)) {
    controlSprintModalV2(element, "forceClose");
    return;
  }

  bootstrapModal(element, "dispose");
};
